<template>   
    <!-- 导航菜单等... -->
    <router-view /> 

</template>
 
<script> 
import{  mapActions  } from 'vuex'; 
import { get } from '@/api/AxiosUtils';
 
export default {
  computed: {
    // ...mapState(['contactList']) 
  },
  mounted() { 
    let pid = this.$local.getItem('pid');
    let tjson = this.$local.getItem('contactJson');  

    if(pid || tjson){
      let tlist  = JSON.parse(tjson);
      this.$store.commit('setPrincessIndex',pid); 
      this.$store.commit('setContactList',tlist); 
    } 

    this.fetchContacts();   
  },
  methods: {
    ...mapActions(['fetchContactList']),
    async fetchContacts() {
      // this.fetchContactList(); 

      try {
        const url = '/api/index/baseInfo';
        const response = await get(url, {}, {}); 
        let _data = response?.data;
        if (_data) {
          this.$store.commit('setContactList', _data.princess || []); 
          this.$store.commit('setProductList', _data.product || []); 
          this.$store.commit('setBaseInfo', _data); 
          const jsonstr = JSON.stringify(_data); 
          this.$local.setItem('baseInfoJson', jsonstr);
        } else {
          console.warn('baseInfo 接口 data 为空', response);
        }  
      } catch (error) {
        console.error('Network Error:', error);
      }
        
    }
  }
};
 
 
</script>

<style lang="scss">
h2,h4,p{
    margin: 0;
    padding: 0;
    line-height: normal;
}
@mixin comm-text-colo{
  background: -webkit-linear-gradient(43deg, #c1924e, #f6eca5 80%) !important;
  -webkit-background-clip: text !important;
  -webkit-text-fill-color: transparent;
}
h2{ 
  @include comm-text-colo;
}
h4{
  font-weight: 1000; 
  @include comm-text-colo;
}

p{
  font-size: 17px !important;
  color: #ffefbf;
  margin-bottom: 10px;
}
@mixin ftalign-center{
  text-align: center;
}
@mixin margin0{
  margin: 0 0 0 0;
}
@mixin padding0{
  padding: 0 0 0 0;
}

@mixin flex-stretch{
    -webkit-align-items: stretch;
    -moz-align-items: stretch;
    -ms-align-items: stretch;
    -ms-flex-align: stretch;
    align-items: stretch;
    -webkit-align-content: stretch;
    -moz-align-content: stretch;
    -ms-align-content: stretch;
    align-content: stretch;
}


:root {
    --wpforms-field-border-radius: 3px;
    --wpforms-field-background-color: #ffffff;
    --wpforms-field-border-color: rgba( 0, 0, 0, 0.25 );
    --wpforms-field-text-color: rgba( 0, 0, 0, 0.7 );
    --wpforms-label-color: rgba( 0, 0, 0, 0.85 );
    --wpforms-label-sublabel-color: rgba( 0, 0, 0, 0.55 );
    --wpforms-label-error-color: #d63637;
    --wpforms-button-border-radius: 3px;
    --wpforms-button-background-color: #066aab;
    --wpforms-button-text-color: #ffffff;
    --wpforms-field-size-input-height: 43px;
    --wpforms-field-size-input-spacing: 15px;
    --wpforms-field-size-font-size: 16px;
    --wpforms-field-size-line-height: 19px;
    --wpforms-field-size-padding-h: 14px;
    --wpforms-field-size-checkbox-size: 16px;
    --wpforms-field-size-sublabel-spacing: 5px;
    --wpforms-field-size-icon-size: 1;
    --wpforms-label-size-font-size: 16px;
    --wpforms-label-size-line-height: 19px;
    --wpforms-label-size-sublabel-font-size: 14px;
    --wpforms-label-size-sublabel-line-height: 17px;
    --wpforms-button-size-font-size: 17px;
    --wpforms-button-size-height: 41px;
    --wpforms-button-size-padding-h: 15px;
    --wpforms-button-size-margin-top: 10px;

    --wpbottommenu-font-size: 12px;
    --wpbottommenu-icon-size: 24px;
    --wpbottommenu-text-color: #cecece;
    --wpbottommenu-h-text-color: #e5da85;
    --wpbottommenu-icon-color: #e0ca72;
    --wpbottommenu-h-icon-color: #e5da85;
    --wpbottommenu-bgcolor: #303030;
    --wpbottommenu-zindex: 9999;
    --wpbottommenu-cart-count-bgcolor: #ff0000;
    --wpbottommenu-wrapper-padding: 10px 0;

    
    --wpforms-nav-underline-color: ##ca903a; 

    --wpforms-nav-text-color: #c1924e;
    --wpforms-nav-text2-color: #f6eca5;  
    
    --wpcomm-color-red:"red";
};
 
body {
    @include margin0;
    @include padding0;
}

</style>